import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { MantineProvider, createTheme, Text } from '@mantine/core';
import MainPage from './pages/mainPage';
import SourcesPage from './pages/sourcesPage';
import './styles.css';
import { IconBrain } from '@tabler/icons-react';

const theme = createTheme({
  fontFamily: 'Inter, sans-serif',
  primaryColor: 'indigo',
  colors: {
    dark: [
      '#C1C2C5', // 0
      '#A6A7AB', // 1
      '#909296', // 2
      '#5c5f66', // 3
      '#373A40', // 4
      '#2C2E33', // 5
      '#1e293b', // 6 - dark-bg
      '#141517', // 7
      '#0f172a', // 8 - card-bg
      '#101113', // 9
    ],
  },
});

function App() {
  return (
    <MantineProvider theme={theme} defaultColorScheme="dark">
      <Router>
        <div className="app-container">
          <header className="modern-header option3">
            <div className="header-content">
              <div className="logo-with-icon">
                <div className="logo-icon">
                  <IconBrain size={32} stroke={1.5} color="#818cf8" />
                </div>
                <Text component="h1" className="site-title">
                  <span className="logo-gradient">Hemiplegic</span>
                  <span>Migraine.com</span>
                </Text>
              </div>
              <nav className="nav-tabs">
                <a href="/" className="nav-tab active">Home</a>
                <a href="/sources" className="nav-tab">Sources</a>
              </nav>
            </div>
          </header>

          <main className="main-content">
            <Routes>
              <Route path="/" element={<MainPage />} />
              <Route path="sources/" element={<SourcesPage />} />
            </Routes>
          </main>

          <footer className="app-footer">
            <div className="footer-content">
              <Text c="gray.4">© {new Date().getFullYear()} HemiplegicMigraine.com</Text>
              <div className="support-links">
                <a
                  href="https://buymeacoffee.com/joedst"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-link"
                >
                  Support This Site
                </a>
              </div>
            </div>
          </footer>
        </div>
      </Router>
    </MantineProvider>
  );
}

export default App;